module.exports = __webpack_public_path__ + "static/img/COC2021-32.886bdfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-32.jpg
// module id = W1HQ
// module chunks = 0